module.exports = __webpack_public_path__ + "img/spread.46c2b065.svg";